<template>
    <div class="grafico-container" @fullscreenchange="teste">
        <ScaleLoader
            class="grafico"
            v-if="loading"
            :loading="loading"
        ></ScaleLoader>
        <div v-else class="grafico">
            <div class="header">
                <div class="row">
                    <div class="sm-7">
                        <div class="title">RECEITA X DESPESA</div>
                    </div>
                    <div class="sm-5 text-right">
                        <button @click="fullscreen" class="default-button">
                            <font-awesome-icon
                                fixed-width
                                :icon="faExpandAlt"
                            ></font-awesome-icon>
                        </button>
                        <button
                            @click="showModal = true"
                            class="default-button"
                        >
                            <font-awesome-icon
                                fixed-width
                                :icon="faCalendarAlt"
                            ></font-awesome-icon>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="sm-12">
                        <div class="buttons flex justify-between">
                            <select v-model="SubConta">
                                <option
                                    v-for="subconta in SubContas"
                                    :key="subconta"
                                    :value="subconta"
                                >
                                    {{ subconta }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row flex justify-end">
                    <div class="sm-12 text-right padding text-grey">
                        De {{ inicio | date("dd/LL/yyyy") }} até
                        {{ fim | date("dd/LL/yyyy") }}
                    </div>
                </div>
            </div>

            <Chart :config="config" ref="chart"></Chart>
            <Modal
                v-if="showModal"
                @close="showModal = false"
                @confirmed="updateDatas"
            >
                <div class="row">
                    <div class="sm-12 md-6">
                        <input
                            type="date"
                            lang="pt"
                            v-model="inicio"
                            placeholder="Data Início"
                        />
                    </div>
                    <div class="sm-12 md-6">
                        <input
                            type="date"
                            lang="pt"
                            v-model="fim"
                            placeholder="Data Término"
                        />
                    </div>
                </div>
            </Modal>
        </div>
    </div>
</template>
<script>
import api from "/plugins/api";

import ScaleLoader from "vue-spinner/src/ScaleLoader";
import Chart from "./Chart.vue";

//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faExpandAlt } from "@fortawesome/free-solid-svg-icons/faExpandAlt";

import Modal from "~/components/Modal.vue";

const number_format = (value) => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(+value);
};

export default {
    props: ["codigo_condominio", "data_inicio", "data_fim"],
    components: {
        ScaleLoader,
        FontAwesomeIcon: () => import("@fortawesome/vue-fontawesome").then(e => e.FontAwesomeIcon),
        Chart,
        Modal,
    },
    data() {
        return {
            loading: false,
            error: null,
            rows: [],
            subconta: "",
            faCalendarAlt,
            faExpandAlt,
            chart: null,
            dataInicio: null,
            dataFim: null,
            Inicio: null,
            Fim: null,
            showModal: false,
        };
    },
    computed: {
        empresa() {
            return this.$store.state.empresa;
        },
        colors() {
            return this.empresa.colors;
        },
        inicio: {
            get() {
                if (!this.Inicio) {
                    return null;
                }
                return this.Inicio.split("/").reverse().join("-");
            },
            set(value) {
                let [data, hora] = value.split("T");
                this.Inicio = data.split("-").reverse().join("/");
            },
        },
        fim: {
            get() {
                if (!this.Fim) {
                    return null;
                }
                return this.Fim.split("/").reverse().join("-");
            },
            set(value) {
                let [data, hora] = value.split("T");
                this.Fim = data.split("-").reverse().join("/");
            },
        },
        SubConta: {
            get() {
                if (this.subconta == "" && this.SubContas.length != 0) {
                    let [subconta] = this.SubContas;
                    return subconta;
                }
                return this.subconta;
            },
            set(value) {
                this.subconta = value;
            },
        },
        SubContas() {
            let subcontas = this.rows.map(({ subconta }) => subconta);
            return [...new Set(subcontas)];
        },
        Referencias() {
            let referencias = this.rows.map(({ referencia }) => `${referencia}`);
            return [...new Set(referencias)];
        },
        RowsDebito() {
            if (this.SubConta == "") {
                return [];
            }
            let rows = this.rows
                .filter(({ subconta }) => subconta == this.SubConta)
                .map(({ referencia, debito }) => ({ referencia, debito }));
            rows = this.Referencias.map((referencia) => {
                let row = rows.find((row) => {
                    return row.referencia == referencia;
                });
                if (row) {
                    return row.debito;
                }
                return 0;
            });
            return rows;
        },
        RowsCredito() {
            if (this.SubConta == "") {
                return [];
            }
            let rows = this.rows
                .filter(({ subconta }) => subconta == this.SubConta)
                .map(({ referencia, credito }) => ({ referencia, credito }));
            rows = this.Referencias.map((referencia) => {
                
                let row = rows.find((row) => {
                    
                    return row.referencia == referencia;
                });
                if (row) {
                    return row.credito;
                }
                return 0;
            });
            return rows;
        },
        cores() {
            return this.colors.dual;
        },
        config() {
            return {
                type: "bar",
                data: {
                    labels: this.Referencias,
                    datasets: [
                        {
                            label: "Receitas",
                            data: this.RowsCredito,
                            borderColor: this.cores[0],
                            fill: false,
                            backgroundColor: this.cores[0],
                        },
                        {
                            label: "Despesas",

                            data: this.RowsDebito,
                            borderColor: this.cores[1],
                            fill: false,
                            backgroundColor: this.cores[1],
                        },
                    ],
                },
                options: {
                    tooltips: {
                        intersect: false,
                        callbacks: {
                            label: (tooltipitem, data) => {
                                return number_format(tooltipitem.yLabel);
                            },
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    callback(label, index, labels) {
                                        return new Intl.NumberFormat("pt-BR", {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }).format(label);
                                    },
                                },
                            },
                        ],
                    },
                },
            };
        },
    },
    methods: {
        teste(e) {
            if (document.fullscreenElement) {
            } else {
                this.loading = true;
                this.$nextTick(() => {
                    this.loading = false;
                });
            }
        },
        fullscreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                this.$el.requestFullscreen();
            }
        },
        updateDatas() {
            this.dataInicio = this.Inicio;
            this.dataFim = this.Fim;
            this.showModal = false;
        },
        async loadData() {
            this.loading = true;

            try {
                /*
                let records = await resumoReceitaDespesa({
                    CodCondominio: this.codigo_condominio,
                    CodCliente: this.codigo_cliente,
                    DataIni: this.dataInicio,
                    DataFim: this.dataFim
                });
                */
                if (!this.inicio || !this.fim) {
                    return;
                }

                let { data: fechamentos } = await api.get(
                    `condominios/${this.codigo_condominio}/indicadores/${this.inicio}/${this.fim}/receita-despesa`
                );

                let rows = fechamentos
                    .map(({ Referencia, SubContas }) => {
                        return SubContas.map((SubConta) => ({
                            ...SubConta,
                            Referencia,
                        }));
                    })
                    .reduce((acc, subcontas) => [...acc, ...subcontas], [])
                    .map(
                        ({
                            Referencia: referencia,
                            SubConta: subconta,
                            ValorCredito: credito,
                            ValorDebito: debito,
                        }) => ({ referencia, subconta, credito, debito })
                    );

                this.rows = rows;
            } catch (err) {
                this.error = err.message;
            }

            this.loading = false;
        },
    },
    watch: {
        dataInicio() {
            this.Inicio = this.dataInicio;
            this.loadData();
        },
        dataFim() {
            this.Fim = this.dataFim;
            this.loadData();
        },
        data_inicio: {
            immediate: true,
            handler(value) {
                this.dataInicio = value;
            },
        },
        data_fim: {
            immediate: true,
            handler(value) {
                this.dataFim = value;
            },
        },
    },
};
</script>
<style lang="less" scoped>
.grafico-container {
    
    width: 100%;
    
    margin-bottom: 1em;
}
.grafico {
    //padding: 1em;
    height: 100%;
    background-color: white;
    border: 1px solid lightgrey;
    border-radius: 0.5em;
    //margin: 0.5em;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    position: relative;
    &:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }
    .header {
        padding-top: 1em;
    }
    .buttons {
        select {
            width: auto;
        }
        button {
            margin-left: 1em;
        }
    }
    .default-button {
        padding: 13px 13px;
    }
    .title {
        background-color: white;
        color: black;
    }
    .row {
        margin: auto !important;
    }
}
</style>
<style lang="less">
.vdatetime {
    margin: 0.5em;
    input.vdatetime-input {
        border: 1px solid #ddd;
        padding: 1em;
    }
}
</style>